import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface StepFields {}

interface Props extends AbstractStepProps {
	errors: string[];
}

export class ErrorStep extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { errors = [] } = this.props;

		return (
			<>
				<Card.Header className="bg-danger text-center text-white h4 py-2">Hiba történt</Card.Header>
				<Card.Body>
					<List itemStyle="warning-triangle" className="text-danger">
						{errors.map((error, key) => (
							<List.Item key={key}>{error}</List.Item>
						))}
					</List>
				</Card.Body>
				<Card.Footer />
			</>
		);
	}

	protected getComponentName(): string {
		return "ErrorStep";
	}
}
